import { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import SupplierSelectComponent from '../../supplier-select-component/SupplierSelectComponent';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import "../acknowledgment-component/details-acknowledgment.css";
import { useNotificationAPI } from '../../as2-onboarding-component/hooks/useClient';
import { useOktaAuth } from '@okta/okta-react';

const DetailsAcknowledgment = ({ handleKeyDown, usertype, supplierList }) => {
    const { oktaAuth } = useOktaAuth();
    const notificationApi = useNotificationAPI(oktaAuth.getAccessToken());

    const [rows, setRows] = useState([]);
    const [onFilter, setOnFilter] = useState(rows);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [supplierName, setSupplierName] = useState(null);

    const fetchNotifications = async () => {
        try {
            const response = await notificationApi.get(`/notifications/supplier?supplier_number=${selectedSupplier}`);
            const data = response.data;
            console.log('Fetched notifications:', data);
            const notifications = []
            const seenTitles = new Set();

            data.forEach((element) => {
                if (!seenTitles.has(element.notification.title)) {
                    // Add the title to the Set to ensure uniqueness
                    seenTitles.add(element.notification.title);

                    // Push the notification to the array
                    notifications.push({
                        title: element.notification.title,
                        received: element.notification.creation_date.substring(0, 10),
                        status: element.notification_read ? 'Read' : 'Pending',
                    });
                }
            });

            setRows(notifications);
            setOnFilter(notifications);

        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    }

    useEffect(() => {
        fetchNotifications();
    }, [selectedSupplier]);

    const supplierChangeHandler = (event) => {
        const number = event.slice(0, 10);
        const name = event.slice(13);
        setSupplierName(name);
        setSelectedSupplier(number);

        const filteredRows = rows.filter(row => row.supplier === number);
        setOnFilter(filteredRows);
    }

    const handleSort = (key) => {
        const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });
        const sortedRows = [...onFilter].sort((a, b) => {
            if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
            if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        setOnFilter(sortedRows);
    };

    return (
        <Box p={10} >
            <Card className='cardcontainers'  >
                <Typography variant="h3" fontWeight="semibold" component="p" gutterBottom>
                    Supplier <span style={{ color: "red" }}>*</span>
                </Typography>
                <SupplierSelectComponent
                
                    userType={usertype}
                    supplierList={supplierList}
                    supplierChangeHandler={supplierChangeHandler}
                    handleKeyDown={handleKeyDown}
                />
            </Card>
            <br />
            <Box className='supplier-info'>
                <Typography variant='h2' fontWeight="bold" component="p" gutterBottom>
                    {selectedSupplier ? `Notifications for ${supplierName}` : 'Select a supplier to view notifications'}
                </Typography>
            </Box>
            <Box p={2} >
                <TableContainer  >
                    <Table>
                        <TableHead style={{ borderBottom: 'none' }}>
                            <TableRow>
                                <TableCell className="notify-head" onClick={() => handleSort('title')} align="center">
                                    <Typography variant="h3">
                                        Title <UnfoldMoreIcon fontSize="small" />
                                    </Typography>
                                </TableCell>
                                <TableCell className="notify-head" onClick={() => handleSort('received')} align="center">
                                    <Typography variant="h3">
                                        Received <UnfoldMoreIcon fontSize="small" />
                                    </Typography>
                                </TableCell>
                                <TableCell className="notify-head" onClick={() => handleSort('status')} align="center">
                                    <Typography variant="h3" pl={2}>
                                        Status <UnfoldMoreIcon fontSize="small" />
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {onFilter.map((row, index) => (
                                <TableRow key={index} style={{ borderBottom: 'none' }}>
                                    <TableCell colSpan={3} style={{ padding: '1px' }}>
                                        <Box component={Paper} elevation={3} className='details-row'>
                                            <Box className='details'>
                                                <Typography variant="body2" fontWeight="bold">{row.title}</Typography>
                                            </Box>
                                            <Box className='details'>
                                                <Typography variant="body2">{row.received}</Typography>
                                            </Box>
                                            <Box className='details-status'>
                                                <FiberManualRecordIcon fontSize="0.9rem" color={row.status === 'Pending' ? 'error' : 'success'} />
                                                <Typography variant="body2" color={row.status === 'Pending' ? 'error' : '#2e7d32'} fontWeight="bold">{row.status}</Typography>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    )};

export default DetailsAcknowledgment;
